exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-common-async-loader-component-style__loader {\n\twidth: 100%;\n\theight: 71px;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n\talign-items: center;\n}\n", ""]);

// exports
exports.locals = {
	"loader": "src-common-async-loader-component-style__loader"
};